<div class="filter-overlay" *ngIf="isOpen" (click)="toggleDrawer()"></div>
<div class="filter-drawer" [@drawerAnimation]="isOpen ? 'open' : 'closed'">
  <div class="filter-header">
    <div class="filter-title">
      <span class="filter-icon"></span>
      <span>Filter</span>
    </div>
    <button class="close-button" (click)="toggleDrawer()">
      <span class="close-icon"></span>
    </button>
  </div>
  <div class="filter-content" *ngIf="isOpen">
    <!-- Tree View - Only show projected content -->
    <ng-container *ngIf="view === ZONE_VIEWER.TREE_VIEW">
      <ng-content select="[filter]"></ng-content>
    </ng-container>
    <!-- For non-tree views -->
    <ng-container *ngIf="view !== ZONE_VIEWER.TREE_VIEW">
      <!-- Search Input -->
      <div class="search-container" *ngIf="searchEnabled">
        <input
          type="text"
          class="search-input"
          [placeholder]="searchPlaceholder"
          [value]="searchValue"
          (input)="onSearchChange($event)"
        />
      </div>
      <form [formGroup]="filterForm" class="filter-form">
        <!-- Process all checkbox filter groups -->
        <ng-container *ngFor="let group of processedFilters">
          <!-- Checkbox Filter Group -->
          <div class="filter-section">
            <div class="filter-group">
              <div class="filter-group-header" (click)="toggleGroup(group)">
                <span class="group-title">{{ group.label }}</span>
                <span class="arrow-icon" [class.expanded]="group.expanded"></span>
              </div>
              <div
                class="checkbox-container"
                [@expandCollapse]="group.expanded ? 'expanded' : 'collapsed'"
                [formGroupName]="group.id"
              >
                <div class="checkbox-item" *ngFor="let option of group.options">
                  <label class="checkbox-label">
                    <input type="checkbox" [formControlName]="option.id" />
                    <span class="checkbox-text">{{ option.label | truncate:42:'..' }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </form>
    </ng-container>
  </div>
  <div class="filter-footer" *ngIf="view !== ZONE_VIEWER.TREE_VIEW">
    <button 
    class="clear-button" 
    (click)="clearAllFilters()">
    Reset
  </button>
  <button 
    class="apply-button" 
    [class.active]="hasActiveFilters" 
    [disabled]="!hasActiveFilters" 
    (click)="applyFilters()">
    Submit
  </button>
  </div>
</div>